import React from 'react';
import {connect} from 'react-redux';
import Dimensions from 'react-dimensions';
import _ from 'lodash';
import moment from 'moment';
import {Grid} from 'semantic-ui-react';
import {
	Table,
	TableBody,
	TableHeader,
	TableHeaderColumn,
	TableRow,
	TableRowColumn,
	TableFooter
} from 'material-ui/Table';
import IconButton from 'material-ui/IconButton';
import IconNavigateBefore from 'material-ui/svg-icons/image/navigate-before';
import IconNavigateNext from 'material-ui/svg-icons/image/navigate-next';

import {getPayments} from './actions';
import {getShopifyAppConnection} from '../dashboard-emails-page/actions';

import Tab from '../../components/tab';
import PaymentsEmptyState from '../../components/empty-states/payments_empty_state';
import Loading from '../../components/loading';
import GA from '../../helpers/ga';
import PaymentInfoModal from './components/payment-info-modal';

const PAGE_VIEW_NAME = '/dashboard/payments';

export class PaymentsListPage extends React.Component {
	constructor(props) {
		super(props);
		props.getShopifyAppConnection();
		this.state = {
			page: 1,
			limit: 10
		};
	}

	componentDidMount() {
		GA.sendPageView(PAGE_VIEW_NAME);
	}

	componentWillReceiveProps (nextProps) {
		if (nextProps.appConnection && this.props.appConnection !== nextProps.appConnection) {
			nextProps.getPayments(nextProps.appConnection._id, 1, 10);
		}
	}

	render () {
		const paneHeight = this.props.containerHeight - 70;
		let emptyState = <div />;
		if (this.props.payments.length === 0) {
			if (this.props.phase === 'loading') {
				emptyState = <Loading />;
			} else {
				emptyState = <PaymentsEmptyState />;
			}
		}

		return (
			<Tab.Pane
				containerHeight={ paneHeight }
				padding={ 15 }
				headerText='Your Payments'
				subHeaderText='A list of payments you made for Chated.io'
			>
				<Grid textAlign='center'>
					<Grid.Row>
						{ this.generateTable(this, this.props.payments) }
						{ emptyState }
					</Grid.Row>
				</Grid>
				<PaymentInfoModal ref='paymentInfoModal' />
			</Tab.Pane>
		);
	}

	generateTableHeader() {
		return (
			<TableHeader
				displaySelectAll={false}
				adjustForCheckbox={false}
			>
				<TableRow>
					<TableHeaderColumn colSpan={2}>Payment Date</TableHeaderColumn>
					<TableHeaderColumn colSpan={4}>Name</TableHeaderColumn>
					<TableHeaderColumn colSpan={2}>Amount</TableHeaderColumn>
					<TableHeaderColumn colSpan={2}>Service Start Date</TableHeaderColumn>
					<TableHeaderColumn colSpan={2}>Service End Date</TableHeaderColumn>
					{/* <TableHeaderColumn colSpan={2}>Status</TableHeaderColumn> */}
				</TableRow>
			</TableHeader>
		);
	}

	generateTableBody(ctx, payments) {
		const tableRows = _.map(payments, function(payment) {
			return ctx.generateTableRow(ctx, payment);
		});
		return(
			<TableBody
				displayRowCheckbox={false}
				showRowHover={true}>
				{ tableRows }
			</TableBody>
		);
	}

	/*
	 * @return - (string) YYYY-MM-DD
	 */
	getDateString(datetimeString) {
		if (_.isNil(datetimeString) || datetimeString === '') {
			return '-';
		}
		return moment(datetimeString).format('YYYY-MM-DD');
	}

	generateTableRow(ctx, payment) {
		const paymentId = _.get(payment, '_id');
		// const remoteId = _.get(payment, 'remote_id', '');
		const name = _.get(payment, 'name', '');
		const formattedPaymentDate = this.getDateString(_.get(payment,'paid_at'));
		const serviceStartedAtDate = this.getDateString(_.get(payment,'service_started_at'));
		const serviceEndedAtDate = this.getDateString(_.get(payment,'service_ended_at'));
		const amount = `$ ${_.get(payment, 'amount', '')}`;
		// const paymentMethod = this.getPaymentMethodInfo(_.get(payment, 'payment_method', ''));
		// const status = _.get(payment, 'status', '');
		// const description = _.get(payment, 'description', '');

		return (
			<TableRow key={paymentId}>
				<TableRowColumn colSpan={2}>{ formattedPaymentDate }</TableRowColumn>
				<TableRowColumn colSpan={4}>{ name }</TableRowColumn>
				<TableRowColumn colSpan={2}>{ amount }</TableRowColumn>
				<TableRowColumn colSpan={2}>{ serviceStartedAtDate }</TableRowColumn>
				<TableRowColumn colSpan={2}>{ serviceEndedAtDate }</TableRowColumn>
			</TableRow>
		);
	}

	getPaymentMethodInfo(paymentMethodSlug) {
		switch(paymentMethodSlug) {
			case 'shopify_application_charge':
				return 'Shopify';
			default:
				return '';
		}
	}

	generateTableFooter(ctx) {
		const visible = (ctx.props.phase === 'loading' || ctx.props.payments.length === 0);

		const limit = ctx.state.limit;
		const page = ctx.state.page;
		const count = ctx.props.count;
		const startingRowCount = (page - 1) * limit + 1;
		const maxEndingRowCount = (page) * limit;
		const endingRowCount = (page * limit > count)? count : maxEndingRowCount;
		const pagingString = startingRowCount + '-' + endingRowCount + ' of ' + count;
		const pagingButtons = ctx.generateTableFooterPageButtons(ctx);
		return (
			<TableFooter
				adjustForCheckbox={false}
			>
				<TableRow>
					<TableRowColumn colSpan='5'>
						<p style={{marginBottom: '15px'}} hidden={visible}>
							{ pagingString }
						</p>
					</TableRowColumn>
					<TableRowColumn colSpan='5' style={{textAlign: 'right'}} hidden={visible}>
						{ pagingButtons }
					</TableRowColumn>
				</TableRow>
			</TableFooter>
		);
	}

	generateTableFooterPageButtons(ctx) {
		const limit = ctx.state.limit;
		const page = ctx.state.page;
		const count = ctx.props.count;
		const isFirstPage = (ctx.state.page === 1);
		const isLastPage = (page * limit > count);
		return (
			<div>
				<IconButton
					disabled={isFirstPage}
					onClick={ ctx.moveToPreviousPage }>
					<IconNavigateBefore />
				</IconButton>
				<IconButton
					disabled={isLastPage}
					onClick={ ctx.moveToNextPage }>
					<IconNavigateNext />
				</IconButton>
			</div>
		);
	}

	moveToPreviousPage = () => {
		GA.sendEvent(PAGE_VIEW_NAME, 'click', 'PreviousPageButton', 1);
		this.setState({
			page: this.state.page - 1
		});
		this.props.getPayments(this.props.appConnection._id, this.state.page-1, this.state.limit);
	}

	moveToNextPage = () => {
		GA.sendEvent(PAGE_VIEW_NAME, 'click', 'NextPageButton', 1);
		this.setState({
			page: this.state.page + 1
		});
		this.props.getPayments(this.props.appConnection._id, this.state.page+1, this.state.limit);
	}

	handleRowSelection = (selectedRows) => {
		if (selectedRows && selectedRows.length > 0) {
			const i = selectedRows[0];
			this.refs.paymentInfoModal.openModal(this.props.payments[i]);
		}
	}

	generateTable(ctx, payments) {
		return (
			<Table
				selectable={true}
				multiSelectable={false}
				onRowSelection={this.handleRowSelection}>
				{ ctx.generateTableHeader() }
				{ ctx.generateTableBody(ctx, payments) }
				{ ctx.generateTableFooter(ctx) }
			</Table>
		);
	}
}

export function mapsStateToProps ( state ) {
	return {
		meta: state.dashboardPaymentsReducer.meta,
		count: state.dashboardPaymentsReducer.count,
		payments: state.dashboardPaymentsReducer.payments,
		phase: state.dashboardPaymentsReducer.phase,
		appConnection: state.dashboardEmailsReducer.appConnection
	};
}

export function mapsDispatchToProps ( dispatch ) {
	return {
		getShopifyAppConnection () {
			dispatch( getShopifyAppConnection() );
		},

		getPayments (appConnectionId, page, limit) {
			dispatch( getPayments(appConnectionId, page, limit) );
		}
	};
}

export default connect(mapsStateToProps, mapsDispatchToProps)( Dimensions()(PaymentsListPage) );



// WEBPACK FOOTER //
// ./src/containers/dashboard-payments-page/payments-list-page.js